import { ShieldCheck, Gauge, Flame, Skull } from "lucide-react";

const MAP = {
    low: { label: "Low Risk", icon: ShieldCheck, color: "text-[#22c55e]", border: "border-[#22c55e]/40", bg: "bg-[#0c1f12]" },
    medium: { label: "Medium Risk", icon: Gauge, color: "text-[#3b82f6]", border: "border-[#3b82f6]/40", bg: "bg-[#0c1224]" },
    high: { label: "High Risk", icon: Flame, color: "text-[#f97316]", border: "border-[#f97316]/40", bg: "bg-[#1f1108]" },
    demon: { label: "Demon Risk", icon: Skull, color: "text-[#ef4444]", border: "border-[#ef4444]/50", bg: "bg-[#1d0a0a]" },
};

export const RiskBadge = ({ risk = "low", size = "sm" }) => {
    const r = MAP[risk] || MAP.low;
    const Icon = r.icon;
    const padding = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2 py-1 text-xs";
    return (
        <span
            className={`inline-flex items-center gap-1.5 rounded-md border ${r.border} ${r.bg} ${r.color} ${padding} font-medium`}
            data-testid="risk-badge"
            aria-label={r.label}
        >
            <Icon className={size === "lg" ? "w-4 h-4" : "w-3.5 h-3.5"} aria-hidden="true" />
            <span>{r.label}</span>
        </span>
    );
};
